import { Vue, Component, Inject, Prop, Emit } from 'vue-property-decorator'
import { Validator } from 'vee-validate'
import { StatisticalAnalysisCommon, StatisticalAnalysisSidebarItemCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'
import { initialStatisticalAnalysisSidebarSearchTypeState, StatisticalAnalysisSidebarSearchTypeModel, StatisticalAnalysisSidebarSearchTypeOptions, StatisticalAnalysisSidebarSearchTypeState } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar-search-type/statistical-analysis-sidebar-search-type.model'
import { Nullable } from '@/shared/types/app.types'
import { StatisticalAnalysisSearchBySidebarEventEnum } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar-search-by/statistical-analysis-sidebar-search-by.model'
import { StatiscalAnalysisTypeCases, StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeSelectorEnum } from '@/modules/statistical-analysis-module/shared/models/shared.model'

@Component
export default class StatisticalAnalysisSidebarSearchType extends Vue implements StatisticalAnalysisCommon<StatisticalAnalysisSidebarSearchTypeModel> {
    @Prop() readonly label!: string
    @Prop() readonly multiple!: boolean
    @Prop() readonly options!: StatisticalAnalysisSidebarItemCombo[]
    @Prop() readonly preselection!: StatisticalAnalysisSidebarItemCombo | StatisticalAnalysisSidebarItemCombo[]
    @Prop() readonly required!: boolean
    @Prop() readonly modelKey!: string
    @Inject() externalValidator!: Validator
    @Emit()
    finish(): boolean {
        return true
    }

    state: StatisticalAnalysisSidebarSearchTypeState
    constructor() {
        super()
        this.state = initialStatisticalAnalysisSidebarSearchTypeState()
        this.$validator = this.externalValidator
    }

    mounted() {
        this.state.typeSelection = this.state.typeSelection || this.preselection
        this.state.options = this.options
        this.$eventHub.$on(StatisticalAnalysisSearchBySidebarEventEnum.SEARCH_BY_ENTITY_CHANGE, this._onChangeEntity)
        this.finish()
    }

    beforeDestroy() {
        this.$eventHub.$off(StatisticalAnalysisSearchBySidebarEventEnum.SEARCH_BY_ENTITY_CHANGE, this._onChangeEntity)
    }

    get requiredCombo(): string {
        return this.required ? 'required' : ''
    }

    get preselectionCombo(): Nullable<StatisticalAnalysisSidebarItemCombo> | Nullable<StatisticalAnalysisSidebarItemCombo[]> {
        return this.state.typeSelection
    }

    get invalidFeedback(): string {
        const error = this.errors.first(`${this.state.nameComponent}`)
        return error?.replace(`${this.state.nameComponent}`, this.$tc(this.label))
    }

    getTranslatedLabel(item: StatisticalAnalysisSidebarItemCombo): string {
        return this.$tc(item.text)
    }

    clear(): void {
        this.state = {
            ...this.state,
            typeSelection: this.required ? this.preselection : null
        }
    }

    getModel(): StatisticalAnalysisSidebarSearchTypeModel {
        return {
            [this.modelKey]: this.state.typeSelection
        }
    }

    onInput(value: StatisticalAnalysisSidebarItemCombo | StatisticalAnalysisSidebarItemCombo[]): void {
        this.state.typeSelection = value
    }

    private _onChangeEntity(selection: StatisticalAnalysisSidebarItemCombo): void {
        this.state.options = this.state.options.map((option:StatisticalAnalysisSidebarSearchTypeOptions) => {
            if (selection.id === StatiscalAnalysisTypeCases.PORTION || selection.id === StatiscalAnalysisTypeCases.SUBPORTION) {
                if (option.id === StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeSelectorEnum.DELAY) {
                    if ((this.state.typeSelection as StatisticalAnalysisSidebarItemCombo).id === StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeSelectorEnum.DELAY) {
                        this.state.typeSelection = this.state.options.find((option: StatisticalAnalysisSidebarSearchTypeOptions) => {
                            return option.id === StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeSelectorEnum.TRO
                        })
                    }
                    option.$isDisabled = true
                } else {
                    option.$isDisabled = false
                }
                return option
            } else {
                option.$isDisabled = false
                return option
            }
        })
    }
}
